import { formatDate } from "./fecha";

export const removeTabs = (value) => {
  try {
    let val = value.replace(/\t/g, "");
    return val;
  } catch (error) {
    return value;
  }
};

const isValidDate = (date) => date && date.length === 8;
export const dateRangeToStrings = (startDate, finishDate, options) => {
  if (!isValidDate(startDate) && !isValidDate(finishDate)) {
    return options && options.default ? options.default : "";
  }

  let message = "";
  if (isValidDate(startDate)) {
    message += `Desde ${formatDate(startDate)} `;
  }

  if (isValidDate(finishDate)) {
    message += `Hasta ${formatDate(finishDate)} `;
  }

  return message;
};
